import React, { useRef, useEffect, useState } from 'react';
import { User, Bot } from 'lucide-react';

const ChatContainer = ({ messages = [], onSuggestionClick }) => {
    const messagesEndRef = useRef(null);
    const scrollContainerRef = useRef(null);
    const [previousMessageCount, setPreviousMessageCount] = useState(0);

    // Auto-scroll vers le bas quand de nouveaux messages arrivent
    useEffect(() => {
        if (messagesEndRef.current) {
            const isNewMessage = messages.length > previousMessageCount;
            const isInitialLoad = previousMessageCount === 0 && messages.length > 0;

            messagesEndRef.current.scrollIntoView({
                behavior: isInitialLoad ? 'auto' : 'smooth', // Scroll immédiat pour le chargement initial
                block: 'end'
            });
        }
        setPreviousMessageCount(messages.length);
    }, [messages, previousMessageCount]);

    const suggestions = [
        {
            title: "Show me a screener",
            subtitle: "to find new stocks",
            message: "Show me a screener to find new stocks"
        },
        {
            title: "How is the stock market",
            subtitle: "performing today by sector?",
            message: "How is the stock market performing today by sector?"
        },
        {
            title: "What are Microsoft's",
            subtitle: "latest financials?",
            message: "What are Microsoft's latest financials?"
        },
        {
            title: "What are some recent",
            subtitle: "events about Amazon?",
            message: "What are some recent events about Amazon?"
        }
    ];

    return (
        <div className="flex-1 overflow-hidden">
            {messages.length === 0 ? (
                // Message de bienvenue quand pas de messages
                <div className="h-full flex flex-col justify-center items-center px-4 sm:px-6">
                    <div className="text-center mb-6 sm:mb-8 max-w-2xl">
                        <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4">
                            Welcome to Lamien Lite powered by FinAI!
                        </h2>
                        <p className="text-gray-400 text-sm sm:text-base">
                            This is your AI-powered financial analysis assistant. Ask me about market trends, financial data, or specific assets.
                        </p>
                    </div>

                    {/* Suggestions de questions - responsive */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8 max-w-3xl w-full">
                        {suggestions.slice(0, window.innerWidth < 640 ? 2 : 4).map((suggestion, index) => (
                            <div
                                key={index}
                                onClick={() => onSuggestionClick(suggestion.message)}
                                className="p-3 sm:p-4 bg-dark-secondary rounded-lg border border-dark-border 
                         hover:border-gray-500 cursor-pointer transition-all duration-200 
                         hover:bg-opacity-80 active:scale-95"
                            >
                                <h3 className="font-medium mb-1 sm:mb-2 text-sm sm:text-base">{suggestion.title}</h3>
                                <p className="text-xs sm:text-sm text-gray-400">{suggestion.subtitle}</p>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                // Zone des messages avec scroll - hauteur réduite
                <div ref={scrollContainerRef} className="h-full overflow-y-auto px-4 sm:px-6 py-2 sm:py-3">
                    <div className="max-w-3xl mx-auto space-y-3 sm:space-y-4">
                        {messages.map((message, index) => (
                            // <div key={index} className="flex items-start space-x-3">
                            <div key={index}
                                className={`flex items-start ${message.isUser ? 'flex-row-reverse space-x-reverse space-x-3' : 'space-x-3'}`}
                            >
                                {/* Icône */}
                                <div className={`flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center ${message.isUser
                                    ? 'bg-blue-600'
                                    : 'bg-gray-700'
                                    }`}>
                                    {message.isUser ? (
                                        <User size={14} className="sm:w-4 sm:h-4 text-white" />
                                    ) : (
                                        <Bot size={14} className="sm:w-4 sm:h-4 text-white" />
                                    )}
                                </div>

                                {/* Message */}
                                <div className="flex-1 min-w-0">
                                    <div className={`p-2 sm:p-3 rounded-lg ${message.isUser
                                        ? 'bg-blue-600 text-white ml-auto max-w-[80%]'
                                        : 'bg-dark-secondary border border-dark-border text-gray-100'
                                        }`}>
                                        <div className="text-sm sm:text-base whitespace-pre-wrap">
                                            {message.content}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* Élément invisible pour l'auto-scroll */}
                        <div ref={messagesEndRef} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChatContainer;
